import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-chairmans-message',
  templateUrl: './chairmans-message.component.html',
  styleUrls: ['./chairmans-message.component.scss']
})
export class ChairmansMessageComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
